// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1W_hJ","inputWrap":"Table_inputWrap__3vNwS","col":"Table_col__m7RyJ","bmiTooltip":"Table_bmiTooltip__3tHgB"};